import { createContext } from "react";
import { MenuProps } from "react-select";

export const MenuPropsContext = createContext<Partial<MenuProps>>({})